// Question Types
// 1. MCQs | Multiple Choice | single
// 2. boolean | true/false | single
// 3. MAQs | Multiple Answers | multiple

import { Topic } from '.'

export const ruminacao: Topic = {
  topic: 'Ruminação',
  level: 'Intermediate',
  totalQuestions: 10,
  totalScore: 95,
  totalTime: 600,
  questions: [
    {
      question: 'Eu costumo repassar repetidamente os meus problemas e preocupações na minha mente.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Quando enfrento uma situação difícil, tenho dificuldade em parar de pensar nela.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Eu me critico constantemente, relembrando erros do passado.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Fico preso em pensamentos negativos sobre mim mesmo e minha vida.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Quando me sinto triste ou preocupado, costumo analisar minhas emoções minuciosamente em busca de respostas.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Tenho dificuldade em desligar minha mente e me concentrar em outras coisas quando estou chateado.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Revivo frequentemente situações passadas que me causaram dor ou tristeza.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Quando enfrento uma crise, minha mente fica repleta de pensamentos negativos e autocríticos.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Passo muito tempo pensando sobre como as coisas poderiam ter sido diferentes se eu tivesse agido de outra forma.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },
    {
      question: 'Eu costumo ficar obcecado por pensamentos sobre meus problemas e preocupações.',
      choices: [
        { choice: "Nunca se aplica a mim", score: 1 },
        { choice: "Raramente se aplica a mim", score: 2 },
        { choice: "Às vezes se aplica a mim", score: 3 },
        { choice: "Frequentemente se aplica a mim", score: 4 },
        { choice: "Sempre se aplica a mim", score: 5 },
      ],
      type: 'MCQs',
      correctAnswers: [
        'A syntax extension for JavaScript that allows writing HTML-like code in JavaScript',
      ],
      score: 10,
    },

    
    

  ],
}
